import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  DrawerCloseButton,
} from '@stockx/ui';

interface Props {
  handleActionClick: Function;
}
const ListActionDrawer = ({ handleActionClick }: Props) => {
  const { t } = useTranslation();
  const handleEditClick = () => {
    handleActionClick('edit');
  };

  const items = [
    {
      title: t('Edit'),
      key: 'list-edit-dropdown-mobile-menu-edit',
      fn: handleEditClick,
    },
    {
      title: t('Add Item'),
      key: 'list-edit-dropdown-mobile-menu-add-item',
    },
  ];

  return (
    <DrawerContent>
      <DrawerCloseButton />
      <DrawerHeader borderBottomWidth="1px">{t('Actions')}</DrawerHeader>
      <DrawerBody p="0">
        {items.map((item) => (
          <Box
            borderBottom="1px solid"
            borderColor="neutral.200"
            paddingY="4"
            paddingX="6"
            key={item.key}
            onClick={() => handleActionClick(item.title)}
          >
            {item.title}
          </Box>
        ))}
      </DrawerBody>
      <DrawerFooter />
    </DrawerContent>
  );
};

export default ListActionDrawer;
